import { Auth } from "@aws-amplify/auth";

import { useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";

import { Box, Paper, Typography } from "@mui/material";

import { authToken } from "@/api/account";
import { siteName } from "@/constants/config";
import useCheckUserStatus from "@/hooks/useCheckUserStatus";
import useEvent from "@/hooks/useEvent";
import useLayoutData from "@/hooks/useLayoutData";
import useNavigateLogin from "@/hooks/useNavigateLogin";
import useSnackbar from "@/hooks/useSnackbar";
import useUserInfo from "@/hooks/useUserInfo";

function LoginV2() {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const { contentHeight } = useLayoutData();
  const [searchParams] = useSearchParams();
  const { userInfoContext } = useUserInfo();
  const { checkUserStatus } = useCheckUserStatus();

  const { getRedirectUrl } = useNavigateLogin();

  const answerCustomChallenge = useCallback(
    async (token = "", email = "") => {
      try {
        const cognitoUser = await Auth.signIn(email);
        await Auth.sendCustomChallengeAnswer(cognitoUser, token);

        const user = await Auth.currentAuthenticatedUser();

        const userInfo = {
          email: user.attributes.email,
          token: user.signInUserSession.idToken.jwtToken,
          profile_img: user.attributes?.picture,
        };

        userInfoContext.setUserInfo(userInfo);

        navigate(getRedirectUrl() || "/", { replace: true });
      } catch (error) {
        enqueueSnackbar(`The token is invalid.`);
        navigate("/signin", { replace: true });
      }
    },
    [enqueueSnackbar, userInfoContext, navigate, getRedirectUrl]
  );

  const init = useEvent(async () => {
    const result = await checkUserStatus();

    if (!result) return;

    const qsEmail = searchParams.get("email");
    const qsToken = searchParams.get("token");
    const qsCode = searchParams.get("code");

    if (qsEmail && qsCode) {
      console.log("Login with email and code");
      const result = await authToken({
        email: qsEmail,
        code: qsCode,
      });
      const reqToken = result.data.token;
      const email = decodeURIComponent(qsEmail);
      const token = decodeURIComponent(reqToken);

      answerCustomChallenge(token, email);
    } else if (qsToken && qsToken) {
      console.log("Login with email andtoken");
      const email = decodeURIComponent(qsEmail);
      const token = decodeURIComponent(qsToken);

      answerCustomChallenge(token, email);
    }
  });

  useEffect(() => {
    init();
  }, [init]);

  return (
    <Box
      className="grid w-screen transition-all place-items-center"
      sx={{ height: contentHeight + "px" }}
    >
      <Paper
        elevation={4}
        className="!rounded-[20px] max-w-sm w-full"
        sx={{ width: `calc(100% - 32px)` }}
      >
        <div className="py-[30px]">
          <Typography className="text-center !text-[30px] !font-bold">Checking...</Typography>
          <Typography variant="body1" className="text-center pt-[20px] opacity-80">
            <a
              href={"https://www." + siteName + ".com/"}
              className="no-underline text-inherit hover:underline"
            >
              {siteName + ".com"}
            </a>
          </Typography>
        </div>
      </Paper>
    </Box>
  );
}
export default LoginV2;
